import React from 'react'
import OAMSider from '../oam-sider'
import ClusterDetail from '../components/cluster-detail/ClusterDetail'
import {
  Layout,
} from 'antd'

const OAMClusterDetail:React.FC =() =>{
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f5f6f8' }}>
      <OAMSider keys={'cluster_manager'} openKeys={['']}></OAMSider>
      <ClusterDetail mode={"oam"} />
    </Layout>
  )
}

export default OAMClusterDetail